import React from 'react';
import Carousel from '../components/Carousel';
import '../styles/projects.css'

function ProjectsPage(props) {

    return(
        <div className="projects-container">
            <div className="projects-title">My Projects</div>
          <Carousel/>
        </div>
    );

}

export default ProjectsPage;